import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter, HostListener,
  Input,
  OnChanges, OnDestroy, OnInit,
  Output, Renderer2,
  SimpleChanges, ViewChild
} from '@angular/core';
import {Company} from "../../../interfaces/company.interface";
import {Store} from "@ngrx/store";
import {AppState} from "../../../state/app.state";
import {NgClass, NgIf} from "@angular/common";

@Component({
  selector: 'app-icp-score-header',
  standalone: true,
  imports: [
    NgClass,
    NgIf
  ],
  templateUrl: './icp-score-header.component.html',
  styleUrl: './icp-score-header.component.scss'
})
export class IcpScoreHeaderComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

  @Input() report: any;
  @Input() company: Company;

  @Output() icpScoreClicked: EventEmitter<void> = new EventEmitter();
  icpScore: number = null;

  isNarrow: boolean = false;
  private resizeObserver: ResizeObserver;

  constructor(
    private store: Store<AppState>,
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    //
  }

  ngOnInit() {
    // Initialize icpScore if needed
    if (this.report && this.report.icpScore) {
      this.icpScore = this.report.icpScore;
    }

    // Check initial width
    this.checkWidth();
  }

  ngAfterViewInit() {
    // Set up ResizeObserver to watch for size changes
    if (typeof ResizeObserver !== 'undefined') {
      this.setupResizeObserver();
    } else {
      // Fallback for browsers that don't support ResizeObserver
      this.checkWidth();
    }
  }

  private setupResizeObserver() {
    const container = this.el.nativeElement.querySelector('#icp-score-header');

    if (container) {
      this.resizeObserver = new ResizeObserver(() => {
        this.checkWidth();
      });

      this.resizeObserver.observe(container);
    }
  }

  private checkWidth() {
    const container = this.el.nativeElement.querySelector('#icp-score-header');
    if (container) {
      const width = container.offsetWidth;
      this.isNarrow = width < 150;
    }
  }

  // Fallback resize listener for browsers without ResizeObserver
  @HostListener('window:resize')
  onResize() {
    if (!this.resizeObserver) {
      this.checkWidth();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('[icp-score-header.component.ts] ngOnChanges')

    if (changes['company'] && changes['company'].currentValue) {
      // Update the ICP score when the company input changes
      this.icpScore = changes['company'].currentValue.icp_score;
      // console.log('ICP Score updated:', this.icpScore);
    }
  }

  ngOnDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  openIcpScore() {
    this.icpScoreClicked.emit();
  }

}
